import { SEARCH_POLICY_ACTIONS } from './constants';

export const searchPolicy = ({ params }: any) => ({
  type: SEARCH_POLICY_ACTIONS.START,
  payload: params,
});

export const searchPolicyFail = (error: any) => ({
  type: SEARCH_POLICY_ACTIONS.FAIL,
  error,
});

export const searchPolicySuccess = (data: any) => ({
  type: SEARCH_POLICY_ACTIONS.SUCCESS,
  data,
});

export const searchPolicyReset = () => ({
  type: SEARCH_POLICY_ACTIONS.RESET,
});
